import { Component, OnInit, ViewChild, ElementRef } from '@angular/core'; 
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NotificationToastService } from '../../../services/notification-toast.service';
import { MedicalFeePaymentService } from '../../../services/medical-fee/medical-fee-payment.service';
import { FilterCompleteService } from 'src/app/filter-complete/filter-complete';
import { PhysicianFilter } from 'src/app/model/physician-Filter';
import { FilterService } from '../../../services/filter.service';
import { IFilterComponent, SearchFilter } from 'src/app/infrastructure/iFilter-component';
import { FilterRecordService } from 'src/app/services/filter-record.service';
import { MedicalFeePeriodFilter } from '../../../model/medical-fee/medical-fee-period-filter';

@Component({
  selector: 'app-medical-fee-pre-payment-filter',
  templateUrl: './medical-fee-pre-payment-filter.component.html',
  styleUrls: ['./medical-fee-pre-payment-filter.component.css']
})
export class MedicalFeePrePaymentFilterComponent implements IFilterComponent, OnInit {

  form: FormGroup;
  @ViewChild('formElement', {static: false}) formElement: ElementRef;
  filterCompletePhysician: FilterCompleteService<PhysicianFilter>; 

  constructor(  private formBuilder: FormBuilder,
                private medicalFeePaymentService: MedicalFeePaymentService,
                private filterService: FilterService,
                private notificationToastService: NotificationToastService,
                private filterRecordService: FilterRecordService) {


    this.form = this.formBuilder.group({
      number: [''],
      physician: ['']
    }, { validators: this.formEmpty('number', 'physician') });

    this.filterCompletePhysician =
      new FilterCompleteService<PhysicianFilter>([], this.form.controls.physician);
  }

  get f() { return this.form.controls; }

  get filteredPhysicianOptions() { return this.filterCompletePhysician ?
    this.filterCompletePhysician.filteredOptions : []; }

  ngOnInit(): void {

    this.loadPhysicians();
  }

  private loadPhysicians() {
    this.filterService.getPhysiciansFilter().then( ( items ) => {
      this.filterCompletePhysician =
        new FilterCompleteService<PhysicianFilter>(items, this.form.controls.physician);
    });
  }

  getSearchFilters(): SearchFilter[] {
    const requiredTags: string[] = [];
    return this.filterRecordService.convertToSearchFilters(this.form, requiredTags);
  }

  async saveFilters() {
    this.filterRecordService.saveFilters('MedicalFeePaymentFilterComponent', this.form);
  }

  setFilters(): boolean {
    return this.filterRecordService.setFilters('MedicalFeePaymentFilterComponent', this.form);
  }

  async search(): Promise<any> {

      try {

         if ( this.form.valid ) {
          return await this.medicalFeePaymentService.getMedicalFeePrePaymentSearchItems(
            this.form.controls.number.value,
            this.form.controls.physician.value ? this.form.controls.physician.value.Id : null);
        } else {
          this.notificationToastService.error('Debe ingresar al menos un filtro', 'Honorarios');
          return Object.values( this.form.controls ).forEach( control => {
            control.markAsTouched();
          });
          return null;
        }
      } catch ( err ) {

        this.notificationToastService.error(JSON.stringify( err.error ), 'Honorarios');
      }
  }

  formEmpty( number: string, physician: string ) {

    return ( formGroup: FormGroup ) => {

      const numberControl = formGroup.controls[number];
      const physicianControl = formGroup.controls[physician]; 

      if ( !numberControl.value && 
         ( !physicianControl.value || typeof physicianControl.value === 'string' ) ) {
        numberControl.setErrors({ formEmpty: true });
        physicianControl.setErrors({ formEmpty: true });
      } else {
        numberControl.setErrors( null );
        physicianControl.setErrors( null );
      }
    };
  }
}
